import styled from 'styled-components'
import './css-reset.css'
import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Header as MediaLibraryHeader } from './pages/media-library/Header'
import { Body as MediaLibraryBody } from './pages/media-library/Body'
import { Header as VideoLibraryHeader } from './pages/video/Header'
import { Body as VideoLibraryBody } from './pages/video/Body'
import { Header } from './components/Header'

const Container = styled.div`
  direction: rtl;
  font-family: 'Noto Sans Hebrew', sans-serif;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const BodyContainer = styled.main`
  flex: 1;
`

const routePaths = {
  video: '/:videoId',
  main: '/'
}

const App = (): JSX.Element => {
  return (
    <BrowserRouter>
      <Container>
        <Header>
          <Switch>
            <Route path={routePaths.video}>
              <VideoLibraryHeader />
            </Route>
            <Route path={routePaths.main}>
              <MediaLibraryHeader />
            </Route>
          </Switch>
        </Header>
        <BodyContainer>
          <Switch>
            <Route path={routePaths.video}>
              <VideoLibraryBody />
            </Route>
            <Route path={routePaths.main}>
              <MediaLibraryBody />
            </Route>
          </Switch>
        </BodyContainer>
      </Container>
    </BrowserRouter>
  )
}

export default App
